<template>
  <CalcView />
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import CalcView from './views/CalcView.vue'

export default defineComponent({
  name: 'App',
  components: {
    CalcView,
  },
})
</script>

<style lang="scss" src="./styles/style.scss"></style>
